export default "data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="